import type { BusinessUnitCode } from '~/common/model/businessunits/BusinessUnitCode'

export const DHL_NL_BUSINESS_UNIT_CODE: BusinessUnitCode = 'dhl-nl'
export const DHL_BE_BUSINESS_UNIT_CODE: BusinessUnitCode = 'dhl-be'
export const DHL_ES_BUSINESS_UNIT_CODE: BusinessUnitCode = 'dhl-es'
export const DHL_PT_BUSINESS_UNIT_CODE: BusinessUnitCode = 'dhl-pt'
export const DHL_CH_BUSINESS_UNIT_CODE: BusinessUnitCode = 'dhl-ch'
export const DHL_SE_BUSINESS_UNIT_CODE: BusinessUnitCode = 'dhl-se'
export const PPL_CZ_BUSINESS_UNIT_CODE: BusinessUnitCode = 'ppl-cz'
export const CCC_BUSINESS_UNIT_CODE: BusinessUnitCode = 'ccc'

export const KNOWN_BUSINESS_UNIT_CODES: BusinessUnitCode[] = [
  DHL_NL_BUSINESS_UNIT_CODE,
  DHL_BE_BUSINESS_UNIT_CODE,
  DHL_ES_BUSINESS_UNIT_CODE,
  DHL_PT_BUSINESS_UNIT_CODE,
  DHL_CH_BUSINESS_UNIT_CODE,
  DHL_SE_BUSINESS_UNIT_CODE,
  PPL_CZ_BUSINESS_UNIT_CODE,
  CCC_BUSINESS_UNIT_CODE,
]

export const isKnownBusinessUnit = (businessUnitCode: string | undefined): businessUnitCode is BusinessUnitCode => {
  return !!businessUnitCode && KNOWN_BUSINESS_UNIT_CODES.includes(businessUnitCode as BusinessUnitCode)
}

export const isCccBusinessUnit = (businessUnitCode: string | undefined): boolean => {
  return businessUnitCode === CCC_BUSINESS_UNIT_CODE
}

export const isPplCzBusinessUnit = (businessUnitCode: string | undefined): boolean => {
  return businessUnitCode === PPL_CZ_BUSINESS_UNIT_CODE
}

export const isBeNlBusinessUnit = (businessUnitCode: string | undefined): boolean => {
  return businessUnitCode === DHL_NL_BUSINESS_UNIT_CODE || businessUnitCode === DHL_BE_BUSINESS_UNIT_CODE
}
